import userQueries from '@apis/queries/userQueries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pushGtmEvent } from '@utils/gtm';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useToggleMarketingAgreement() {
    const { t } = useTranslation('accountSetting');
    const queryClient = useQueryClient();
    const toast = useToast();
    const { data: user } = useQuery(userQueries.detail());
    const { mutate } = useMutation({
        mutationFn: UserApi.toggleMarketingAgreement,
        onSuccess() {
            // 토글 API 라서 변경 전 값의 반대가 변경 후 동의 여부다
            pushGtmEvent({
                event: 'marketing_agree',
                agreed: !user?.marketingAgreed,
            });
            queryClient.invalidateQueries({ queryKey: userQueries.detail._def });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e?.response?.data.message || t('toast.unknownError'));
        },
    });
    return () => mutate();
}

export default useToggleMarketingAgreement;
